import styles from './style.module.css';

import { useEffect, useState } from 'react';
import { List, ListItem } from '../List';

import { getStepIcons } from '../../utils/stepIcons';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

interface ILeadSteps {
  step?: any;
  stepsNames: any;
  product?: string;
  registerDate?: string;
  description?: string;
  phone?: string;
  isCanceled?: string | boolean;
  businessName?: string;
  lead?: any;
  client?: any;
  player?: any;
  idCustomer?: string;
}

export function LeadSteps({
  step,
  product,
  registerDate,
  phone,
  stepsNames,
  description,
  isCanceled,
  businessName,
  lead,
  client,
  player,
  idCustomer,
}: ILeadSteps) {
  const [stepsListsImagesAdaptative, setStepsListsImagesAdaptative] =
    useState<Array<string>>();
  const [stepsListsTextsAdaptative, setStepsListsTextsAdaptative] =
    useState<Array<string>>();

  useEffect(() => {
    setStepsListsImagesAdaptative(getStepIcons(stepsNames.length));
    setStepsListsTextsAdaptative(
      stepsNames.map((step: { name: string }) => step.name)
    );
  }, []);

  const renderPreferenceInputs = (preferences) => {
    return preferences
      .filter((item) => item !== null && item !== undefined)
      .map((item) => (
        <ListItem content="imobiliária" secondaryContent={item.label} />
      ));
  };

  return (
    <>
      <div className={styles.stepsWrapper}>
        {stepsNames.map((steps: object, index: number) => {
          const stepLead = stepsListsTextsAdaptative?.indexOf(
            stepsListsTextsAdaptative[index]
          );

          return (
            <>
              {index === 0 && (
                <div
                  className={`${styles.step} ${styles.active} ${
                    step === stepLead
                      ? isCanceled
                        ? styles.canceled
                        : styles.progress
                      : ''
                  }`}
                >
                  <img
                    src={
                      stepsListsImagesAdaptative
                        ? stepsListsImagesAdaptative[index]
                        : ''
                    }
                    alt=""
                  />
                </div>
              )}

              {index > 0 && (
                <div
                  className={`${styles.step} ${
                    stepLead && step >= stepLead ? styles.active : ''
                  } ${
                    step === stepLead
                      ? isCanceled
                        ? styles.canceled
                        : styles.progress
                      : ''
                  }`}
                >
                  <img
                    src={
                      stepsListsImagesAdaptative
                        ? stepsListsImagesAdaptative[index]
                        : ''
                    }
                    alt=""
                  />
                </div>
              )}

              {index < stepsNames.length - 1 && (
                <div className={styles.divider}></div>
              )}
            </>
          );
        })}
      </div>
      <div className="mt-3">
        <span className="fw-semibold">Mais detalhes</span>
      </div>
      {client && client.clientUrl === 'bomnegocio' && (
        <iframe
          src={`https://maps.google.com/maps?q=${
            lead && lead.geoReference && lead.geoReference.lat
          },${
            lead && lead.geoReference && lead.geoReference.lng
          }&hl=pt&z=17&output=embed`}
          style={{ width: '100%', height: '300px', border: '0' }}
        ></iframe>
      )}

      <List>
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Solicitação"
            secondaryContent={lead.patrimonTypeAction}
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem content="Tipo" secondaryContent={lead.patrimonType} />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem content="CEP" secondaryContent={lead.patrimonCep} />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Endereço"
            secondaryContent={
              lead && lead.geoReference && lead.geoReference.address
            }
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Estado"
            secondaryContent={
              lead && lead.geoReference && lead.geoReference.state
            }
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Cidade"
            secondaryContent={
              lead && lead.geoReference && lead.geoReference.city
            }
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Bairro"
            secondaryContent={
              lead && lead.geoReference && lead.geoReference.district
            }
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Faixa de preço"
            secondaryContent={lead.patrimonPrice}
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Imóvel com exclusividade?"
            secondaryContent={lead && lead.patrimonUnique ? 'Sim' : 'Não'}
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Preferência por alguma imobiliária?"
            secondaryContent={lead && lead.patrimonPreference ? 'Sim' : 'Não'}
          />
        )}
        {client &&
          client.clientUrl === 'bomnegocio' &&
          lead &&
          lead.patrimonPreferenceNames &&
          renderPreferenceInputs(lead && lead.patrimonPreferenceNames)}
        <ListItem
          content="Step"
          secondaryContent={
            stepsListsTextsAdaptative ? stepsListsTextsAdaptative[step] : ''
          }
        />
        {idCustomer && player.regional === 'sim' && (
          <ListItem content="ID CRM" secondaryContent={idCustomer} />
        )}
        {product && <ListItem content="Produto" secondaryContent={product} />}
        {registerDate && (
          <ListItem
            content="Horário de criação"
            secondaryContent={registerDate}
          />
        )}
        {phone &&
          client?.phoneEnable === 'true' &&
          player?.regional === 'sim' && (
            <ListItem content="Telefone" secondaryContent={phone} />
          )}
        {description && (
          <ListItem content="Origem" secondaryContent={description} />
        )}
        {businessName && (
          <ListItem content="Corretor" secondaryContent={businessName} />
        )}
      </List>
      {phone &&
        client?.phoneEnable === 'true' &&
        player?.regional === 'sim' && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px',
            }}
          >
            <button
              style={{
                backgroundColor: '#25D366',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                cursor: 'pointer',
                fontWeight: 600,
              }}
              onClick={() => {
                if (phone) {
                  let formattedPhone = phone.replace(/\D/g, '');

                  if (!formattedPhone.startsWith('55')) {
                    formattedPhone = '55' + formattedPhone;
                  }

                  // WhatsApp exige telefone SEM o zero do DDD, remove o zero à esquerda do DDD se houver
                  formattedPhone = formattedPhone.replace(
                    /^55(0\d{2})/,
                    '55$1'.replace('0', '')
                  );

                  const message = encodeURIComponent(
                    `Olá, ${lead.name}! Meu nome é ${player.name} da ${client.clientUrl}. Tudo bem?`
                  );
                  window.open(
                    `https://wa.me/${formattedPhone}?text=${message}`,
                    '_blank'
                  );
                }
              }}
            >
              <ChatBubbleOutlineIcon
                style={{ width: '17px', height: '17px', marginRight: '5px' }}
              />
              Chamar no WhatsApp
            </button>
          </div>
        )}
    </>
  );
}
